import React from 'react';

import yuanjing from './assets/img/yuanjing.jpg';
import zuzhijigou from './assets/img/zuzhijigou.jpg';
import guanli from './assets/img/guanli.png';
import zerenren from './assets/img/zerenren.png';
import guanli4 from './assets/img/guanli4.png';
import luoji6 from './assets/img/luoji6.png';


import mubiao1 from './assets/img/mubiao1.png';
import fangxiang2 from './assets/img/fangxiang2.png';
import jiaodian3 from './assets/img/jiaodian3.png';
import buzhou4 from './assets/img/buzhou4.png';
import smart5 from './assets/img/smart5.png';
import nengli6 from './assets/img/nengli6.png';
import dinglv7 from './assets/img/dinglv7.png';
import mijue8 from './assets/img/mijue8.png';
import lingdaoli9 from './assets/img/lingdaoli9.png';

import xiaoshoulv from './assets/img/xiaoshoulv.png';
import jiyalv from './assets/img/jiyalv.png';
import chayilv from './assets/img/chayilv.png';
import nianzhoulv from './assets/img/nianzhoulv.png';
import zuzhijigouyilantu from './assets/img/zuzhijigouyilantu.png';


const Section1 = () => <div>
    <h1 name="0-0" className="point" id="point1">第一章 公司概况</h1>
    <h2 name="0-0-0" className="point" id="point2">一、 企业文化</h2>
    <div style={{textAlign: 'center'}}>
        <br/>
        <p><strong>愿景：</strong>我们要做全球最强的商用车产业链平台运营商！</p>
        <p><strong>使命：</strong>让天下商用车用户全程无忧，让我们的员工及合作伙伴都能过上好日子！
        </p>
        <p><strong>价值观：</strong>笃实、诚信、创新、共赢！</p>
        <p><strong>企业信条：</strong>细节决定成败，态度成就未来！</p>
        <p><strong>职业标准：</strong>专业品质，周到服务，从心出发，负责到底！</p>
        <p><strong>行动口号：</strong>脚踏实地、步步为营；抬头做事，低头做人！</p>
    </div>
    <br/><br/>
    <h2 name="0-0-1" className="point" id="point3">二、 《企业简介》文件</h2>

    <h3 name="0-0-1-0" className="point" id="point4"> 1、
        企业简介</h3>
    <div style={{textIndent: '2em'}}>
        <p>云豪投资（北京）有限公司简称“云豪集团”，启始于1999年，集商用车整车定制和组装、专用车改装、整车营销网络、互联网营销、商用车零部件营销、商用车维修服务、商用车应用技术培训、二手车营销、汽车金融、车险、新能源
            汽车服务等主营业务为一体的商用车实业公司。</p>
        <p>自有品牌：“En-How汽车”、“海潮牌”消防车；</p>
        <p>代理进口品牌：瑞典斯堪尼亚商用车、德国MAN、德国威伯科、福伊特传动、ZF、美国美驰；唐纳森滤清器、伊顿离合器等；</p>
        <p>代理国产品牌：上汽红岩依维柯、陕汽重卡、中国重汽、欧曼重卡、银隆客车、欧辉客车、金龙客车、大运重卡、徐工重卡；潍柴动力、康明斯动力、玉柴动力、上柴动力；綦江齿轮、法士特传动；
            汉德车桥、方盛车桥；中车电机等；</p>
        <p>代理配件中心库：潍柴动力、陕汽重卡、北奔重卡、中国重汽、法士特齿轮等；</p>
        <p>云豪集团总部位于北京市大兴区，在国内以北京为中心在天津、河北、辽宁、黑龙江、新疆、内蒙古设有分公司，形成设计组装、销售、后市场服务，培训、展示、客户体验为一体的商用车应用解决方案综合平台；在北京市延庆区设有一个大型综合生产服务基地。</p>
        <p>云豪集团在海外紧跟“一带一路”步伐，响应国家政策在尼日利亚、埃塞俄比亚自建商用车工业园，完善国外KD组装、销售、汽车金融、售后服务等价值链；在泰国成立合资公司，重点发展当地的物流项目和轻卡租卖，以及电动车和中巴车辆的开发项目；在阿联酋迪拜设有二手车交易公司；在沙特设有汽车维修厂；此外，云豪集
            团在美国、香港、玻利维亚、苏丹、厄瓜多尔、巴基斯坦、塔吉克斯坦等地设有项目部。</p>
        <p>云豪集团现有技工500余人，其中“云豪车服”是云豪集团的优势产品，“云豪车服”服务品牌，专注于商用车服务行业20余载，多样的“移动车间”理念，
            专业的技师队伍，一键报修“云豪车服APP”，加上线下配件供应链保障体系，为全球客户提供“一站式维保”解决方案</p>
            
    </div>
    <br/><br/>
    <h3 name="0-0-1-1" className="point" id="point5">2、 愿景图</h3>
    <img src={yuanjing} alt="愿景图" style={{
        width: '900px',
        display: 'block',
        margin: '0 auto'
    }}/>
    <br/><br/>
    <h2 name="0-0-2" className="point" id="point6">三、 发展历程</h2>
    <div style={{textIndent: '2em'}}>
    <h3> 1999年成立</h3>
        <p>1999年 北京綦齿机电有限公司成立</p>
        <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;同年签约綦江齿轮华北总代理</p>
        <h3>2000-2004 丰富的商用车维修技术和配件营销基础</h3>
        <p>2000年 服务站扩建至昌平</p>
        <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;同年签约潍柴动力、陕汽服务商</p>
        <p>2001年 签约陕齿、重汽、川汽服务商</p>
        <p>2002年 签约德国威伯科北方大区销售服务代理</p>
        <p>2003年 签约欧曼服务商</p>
        <p>2004年 签约三一重工、福田重机服务商</p>
        <h3>2005-2009 形成完整的商用车整车营销体系，实现进口、国产品牌全覆盖</h3>
        <p>2005年 在北京朝阳建立服务基地</p>
        <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;签约斯堪尼亚商用汽车成为北区首家全功能经销商</p>
        <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;签约斯堪尼亚专用车底盘全国总代理</p>
        <p>2006年 潍柴动力北京配件中心成立</p>
        <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;签约福田欧曼整车销售代理</p>
        <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;签约上汽红岩依维柯销售服务商</p>
        <p>2007年 签约北方奔驰车桥厂及汉德车桥销售服务商</p>
        <p>2008年 成立北京欧豪汽车销售公司</p>
        <h3>2010-2014 国际市场同步扩展</h3>
        <p>2010年 筹建大兴基地</p>
        <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;开拓海外市场成立苏丹项目部</p>
        <p>2011年 大兴基地一期完成，具备培训接待能力</p>
        <p>2012年 海外市场成立安哥拉和厄瓜多尔项目部</p>
        <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;大兴基地二期建设</p>
        <p>2013年 大兴基地二期完工，新维修厂运营</p>
        <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;怀柔基地和天津基地工程建设开始</p>
        <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;签约陕汽北京中心库</p>
        <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;与乌兰浩特职业学院达成战略合作</p>
        <p>2014年 拓展非洲、美洲海外项目</p>
        <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;收购通州基地，筹划集团公司建设</p>
        <p>2015-2018 追随“一带一路”海外建厂</p>
        <p>2015年 天津基地投入运营</p>
        <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;注册成立云湖春煜（天津）资产管理有限公司</p>
        <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;注册成立云豪投资（北京）有限公司，集团公司成立</p>
        <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;注册成立尼日利亚亚非国际莱基自由贸易区公司</p>
        <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;注册成立埃塞俄比亚卡车制造有限公司</p>
        <p>2016年 新疆基地扩建</p>
        <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;延庆基地建设开始</p>
        <p>2017年 成立欧豪汽车（沈阳）公司，并投入使用</p>
        <p>2018年 成立欧豪汽车（石家庄）公司</p>
        <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;建立法士特中心库</p>
        <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;签约陕汽重卡销售服务一级经销商</p>
        <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;延庆基地、尼日利亚基地、埃塞俄比亚基地均正式投入使用</p>
        <h3>2019  进入整车研发、生产领域，形成商用车全产业链无缝连接</h3>
        <p>2019年 荣获北京市首批二手商用车出口资质</p>
        <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;完成对原北京消防器材厂的收购</p>
        <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;成立中汽北消（北京）应急装备科技有限公司</p>
        <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;延庆基地全面建成</p>
        <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;沈阳公司顺利开业</p>
        <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;与包头机电校企合作落地</p>
        <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;与安哥拉公司形成战略合作</p>
        <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;沙特Nor Motors公司正式运营</p>
        <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;迪拜二手车交易公司注册完成</p>
        <p>2020年 云豪车服APP上线使用</p>
        <p>2021年 注册成立云豪车服（北京） 科技服务有限公司</p>   
    </div>
    <br/><br/>
    <h2 name="0-0-3" className="point" id="0-0-3">四、 云豪集团机构设置</h2>


    <div style={{textIndent: '2em'}}>

        <h3 name="0-0-3-0" className="point" id="0-0-3-0">一、云豪集团组织机构图</h3>
        <div>
            <img src={zuzhijigou} alt="云豪集团组织机构图" style={{
                width: '900px',
                display: 'block',
                margin: '0 auto'
            }}/>
        </div>
        <br/><br/>
        <h3>二、云豪集团本部管理机构图</h3>
        <div>
            <img src={guanli} alt="云豪集团本部管理机构图" style={{
                width: '700px',
                display: 'block',
                margin: '0 auto'
            }}/>
        </div>
        <br/><br/>
   
        <div>
            <h3>三、云豪集团区域行政管理责任人一览表</h3>
            <div>
                <img src={zerenren} alt="云豪集团区域行政管理责任人一览表"
                     style={{
                         width: '500px',
                         display: 'block',
                         margin: '0 auto'
                     }}/>
            </div>
            <br/><br/>
            <h3 name="0-0-3-1" className="point" id="point9">一、集团本部总裁、副总裁、总裁助理人事安排公示：</h3>
            <div style={{textIndent: '2em'}}>
                <p><strong>董事长兼总裁：</strong>王云厅</p>
                <p><strong>党支部书记：</strong>韩立学，主管党支部、监察部</p>
                <p><strong>副董事长：</strong>傅雪梅，主管财务中心，监管集采中心</p>
                <p><strong>财务总监：</strong>郝惠东，主管财务中心，向副董事长汇报工作
                </p>
                <p><strong>行政副总裁：</strong>郭军，主管工会、人力资源部、云豪学院、企宣部、资产部、法务部
                </p>
                <p><strong>营销副总裁：</strong>武晓亮，主管整车品牌营销机构，代表公司对外业务交流
                </p>
                <p><strong>技术副总裁：</strong>孟庆彪，主管配件业务管理公司，监管后市场机构、技术中心，代表公司对外业务交流
                </p>
                <p><strong>总裁助理：</strong>李栋卫，主管电商中心</p>
                <p><strong>总裁助理：</strong>徐桦，主管孵化中心</p>

                <h3 name="0-0-3-2" className="point" id="point9">二、集团本部监管/支持机构经理人事安排公示：</h3>
                <h4>1.财务中心</h4> 
                <p>总监：郝惠东，为该中心的第一责权人，对副董事长汇报工作。</p>
                <h4>2.集采中心</h4>
                <p>负责人：朱莹莹（兼）</p>
                <h4>3.技术中心</h4>
                <p>总经理：高乐，全面负责该中心人、财、物、产、供、销， 为该中心的第一责权人。</p>
                <p>4.人力资源部经理：潘莎莎</p>
                <p>5.办公室主任：吕洪波</p>
                <p>6.云豪学院院长：郭海江</p>
                <p>7.资产部经理：王剑英</p>
                <p>8.法务部（负责人）：郑彬  </p>
                <h3>三、集团公司营销机构总经理、副总经理人事安排公示：</h3>
                <h3>1.卡车业务管理公司</h3>
                <p><strong>总经理：</strong>武晓亮，全面负责该公司人、财、物、产、供、销，为该管理公司的第一责权人。主管斯堪尼亚北京公司、天津斯堪尼亚、石家庄斯堪尼亚、沈阳斯堪尼亚、专用车底盘事业部、新疆公司；监管整车品牌营销一部、整车品牌营销二部、天津红岩品牌部。
                </p>
                <p><strong>副总经理：</strong>范晓康，主管整车品牌营销一部、整车品牌营销二部、天津红岩品牌部，对总经理汇报工作。</p>
                <p><strong>副总经理：</strong>车立民，主管专用底盘事业部，监管进口整车营销，对总经理汇报工作，服从总经理的工作安排。</p>
                <p><strong>副总经理：</strong>黎勇，主管金融保险部，对总经理汇报工作，服从总经理的工作安排。</p>
                <p><strong>总经理助理：</strong>杨忠林，负责卡车业务管理公司各地区公司的民品销售支持工作，斯堪尼亚零售业务牵引车价格管控，负责销售人员的培训，对总经理汇报工作。</p>
                <p>1.1斯堪尼亚北京公司总监：刘成志（二级）</p>
                <p>1.2天津斯堪尼亚总监：吴苏腰拉吐（副总监主持工作）</p>
                <p>1.3石家庄斯堪尼亚总监：蔺帅（一级）</p>
                <p>1.4沈阳斯堪尼亚总监：张雨（一级）</p>
                <p>1.5专用底盘事业部总监：车立民（三级）</p>
                <p>1.6整车品牌营销一部  负责人：李超（副总监主持工作）</p>
                <p>1.7整车品牌营销二部  负责人：张建春（副总监主持工作）</p>
                <p>1.8天津红岩品牌部总监：武文栋（二级）</p>

                <h3>2.客车业务管理公司</h3>
                <p><strong>总经理：</strong>张少先，全面负责该公司人、财、物、产、供、销，为该管理公司的第一责权人，主管锂电池再制造事业部、綦齿事业部，监管威伯科事业部、天津客车事业部，兼任孵化中心副总经理。</p>
                <p><strong>副总经理：</strong>王云伟，主管威伯科事业部、兼管天津客车事业部，（兼任二手车出口事业部车源采购工作）。</p>
                <p><strong>副总经理：</strong>霍涛，主管锂电池再循环事业部，服从总经理的工作安排，对总经理汇报工作。</p>
                <p>2.1锂电池再制造事业部总监：霍涛 </p>
                <p>2.2綦齿事业部总监：吕建龙（一级）</p>
                <p>2.3威伯科事业部总监：韩磊（一级）</p>
                <p>2.4天津客车事业部总监：王珂（副总监主持工作</p>

                <h3>3.云豪车服管理公司</h3>
                <p><strong>总经理：</strong>刘永强，全面负责该公司人、财、物、产、供、销，为该管理公司的第一责权人，主抓全面工作，向董事长汇报工作。</p>
                <p><strong>副总经理：</strong>张琳，主管系统应用部全面工作，分管云豪车服APP全面工作，服
从总经理的工作安排，对总经理汇报工作。</p>
                <p>3.1云豪车服APP：周超（二级）</p>
                <p>3.2大兴车服事业部总监：张东生（三级）</p>
                <p>3.3延庆车服事业部总监：白亚平（一级）</p>

                <h3>4.云豪备品管理公司</h3>
                <p><strong>总经理：</strong>孟庆彪，全面负责该公司人、财、物、产、供、销，为该管理公司的第一责权人，向董事长汇报工作。</p>
                <p><strong>副总经理：</strong>苗东，主管海外市场业务，兼任沙特 NOR MOTORS 公司总经理、迪拜 NOR MOTORS公司总经理，针对云豪备品管理公司业务向总经理汇报工作，配合总经理完成本管理公司出口工作。有权指挥管理公司下级职员配合工作。</p>
                <p><strong>副总经理：</strong>李信，主管仓储物流部，监管采购部，向总经理汇报工作，服从上级领导工作安排。</p>
                <p>4.1采购事业部总监：朱莹莹（三级）</p>
                <p>4.2销售事业部总监：刘天双（二级）</p>
                <p>4.3市场部总监：周文青（一级）</p>
                <p>4.4物流仓储部总监：李信（兼）</p>
                <p>4.5 品牌管理委员会</p>
                <p>朱莹莹：潍柴中心库、北奔中心库、盖茨品牌</p>
                <p>刘天双：陕汽中心库、威伯科中心库（卡车部分）、汉德中心库</p>
                <p>周文青：法士特中心库、伊顿离合器中心库</p>
                <p>汪振清：重汽轻卡中心库</p>
                <p>李敬东：重汽重卡中心库</p>

                <h3>5.中汽北消装备公司</h3>
                <p><strong>总经理：</strong>刘革，全面负责该公司人、财、物、产、供、销，为该管理公司的第一责权人，对董事长汇报工作。</p>
                <h3>6.海外业务管理公司</h3>
                <p><strong>总经理：</strong>王云厅（兼）</p>
                <p><strong>副总经理：</strong>范晓瑞（二级总监主持工作），全面负责该管理公司人、财、物、产、供、销，为该管理公司的第一责权人，对总经理汇报工作。</p>
                <p>6.1营销事业部：负责人：范晓瑞（兼）</p>
                <p>6.2二手车事业部：负责人：冯燕飞（三级总监）</p>
                <p>6.3尼日利亚亚非国际董事总经理：李勇</p>
                <p>6.4埃塞E TRUCK董事总经理：胡颇</p>
                <p>6.5泰国公司董事总经理：王勇</p>
                <p>6.6沙特NOR MOTORS总经理：苗东</p>
                <p>6.7 迪拜NOR MOTORS负责人：马洪龙</p>


            </div>
        </div>
    </div>
    <h2 name="0-0-4" className="point" id="point10">五、
        专有名词定义</h2>
        <h3 >一、云豪“五一通则”定义：</h3>
        <p>1、一概的分配原则——按劳取酬，每个人都要有老板思维；</p>
        <p>“创业空间”是我们迈出的第一步。</p>
        <p>2、一部《员工手册》——全体员工权利与义务的统一；</p>
        <p>3、一致的工作套路——云豪九步工作法；</p>
        <p>4、一统的价值观——笃实、诚信、创新、共赢；</p>
        <p>5、一脉传承的企业文化——“牛文化”、“家文化”、“学习文化”；</p>

    <div>
        <h3>二、 管理:</h3>
        <div style={{textIndent: '2em'}}>
            <p>管理即“管”和“理”两个层面。</p>
            <p>1、“管”，就是权管，用已获得的权利去聚拢团队、制订规矩、制订流程。</p>
            <p>2、“理”，就是梳理，找出现存的矛盾点、找到内部短板以及自己的长板、随时看目标。</p>
            <p>3、企业内部管理中补齐短板，在市场竞争中使用自己的长板。</p>
            <p>4、企业管理的过程中就是一个解决矛盾的过程。</p>
            <p>我们现在营销企业的四个矛盾点：</p>
            <p>（1）与上游厂家或资源提供方的矛盾</p>
            <p>（2）与下游客户及用户资源需求方的矛盾</p>
            <p>（3）营销团队与投资方的纵向矛盾</p>
            <p>（4）团队内部间的横向矛盾</p>
            <div>
                <img src={guanli4} alt="" style={{
                    width: '500px',
                    display: 'block',
                    margin: '0 auto'
                }}/>
            </div>
        </div>
        <br></br>
        <h3>三、 主管与负责的区分</h3>
        <div style={{textIndent: '2em'}}>
            <p>1、主管：主要是管，除了管指定的机构外还有其它的工作。主管是单向的。</p>
            <p>2、负责：负，肩负使命与权利；责，承担责任。负责是全面的、双向的。</p>
        </div>
        <br/><br/>
        <h3>四、 主抓、主管、监管、兼管的区分</h3>
        <div style={{textIndent: '2em'}}>
            <p><strong>1、主抓： </strong>支持为主，重点突破，主要是指上级领导对下级机构的工作行为，往往是阶段性的。
            </p>
            <p><strong>2、主管： </strong>专职管理某一个领域。</p>
            <p><strong>3、监管：</strong>监督与协管，监管是对过程负责，对结果不承担主要责任。
            </p>
            <p><strong>4、兼管：</strong>兼职管理，主要指除对本辖机构外其它机构的管理，是阶段性的但也要负全面责任。
            </p>
        </div>
        <br></br>
        <h3>五、 横向管理与纵向管理的区分</h3>
        <div style={{textIndent: '2em'}}>
            <p><strong>1、横向管理：</strong>同级别机构，业务内容不同时的管理归属权，可以解决管理人员过多的矛盾。
            </p>
            <p><strong>2、纵向管理：</strong>不同级别机构，业务雷同时的管理归属权，可以解决跨区域管理的矛盾。
            </p>
        </div>
        <br></br>
        <h3>六、 岗位职责、能力等级、业务范围、业务流程、作业标准的定义</h3>
        <div style={{textIndent: '2em'}}>
            <p>1、岗位职责和能力等级针对的是个人，能力等级是对一个人本职工作能力的客观评价。以云豪集团“九级能力范畴”为基础来评定，有他评和自评两种方式，遵循360度测评原理。岗位责任对应着基本工资，是员工在此岗位的义务。</p>
            <p>2、业务范围针对个人也针对一个集体，让个人或集体清晰该做什么不该做什么。</p>
            <p>3、业务流程是针对某项业务展开的几个人或几个环节形成的一个链条，针对的是事情。</p>
            <p>4、作业标准是针对一个业务流程是否是合格的用度量的概念去标定，针对的是事 情的结果。</p>
        </div>
        <br></br>
        <h3>七、 企业运营的逻辑 </h3>
        <div>
            <img src={luoji6} alt="" style={{
                width: '800px',
                display: 'block',
                margin: '0 auto'
            }}/>
        </div>
        <br></br>
        <h3>八、 销、人、物、供、产、财的定义</h3>
        <div style={{textIndent: '2em'}}>
            <p><strong style={{textIndent: '2em'}}>人：</strong>团队建设
            </p>
            <p><strong style={{textIndent: '2em'}}>财：</strong>财务状态、现金流状态
            </p>
            <p><strong style={{textIndent: '2em'}}>物：</strong>生产资料，如库存、办公场所、设备等
            </p>
            <p><strong style={{textIndent: '2em'}}>产：</strong>品牌发展、生产安全
            </p>
            <p><strong style={{textIndent: '2em'}}>供：</strong>供应链整合、成本控制
            </p>
            <p><strong style={{textIndent: '2em'}}>销：</strong>营销模式、客户状态、市场状态
            </p>
        </div>
        <br></br>
        <div style={{textIndent: '2em'}}>
            <h3>九、关于库存管理的定义：</h3>
            <p>1、计划周期：一个自然年，年初第一个订单到年末最后一个订单结束为一个计划周期；</p>
            <p>2、<img src={xiaoshoulv} alt="" style={{ height: '50px'}}/></p>
            <p> 2.1、销存率主要用于鉴定计划采购岗位对于物资采购及时性、准确性、经济性衡量的主要参考依据。</p>
            <p> 2.2、汽车行业销存率的标准K值为8.5，每月计划一次（全年12次），计划数量为下个月的预计销售数量。</p>
            <p> 2.3、要求计划员随时掌握市场需求状态，随时和营销、生产一线对接。</p>
            <p>3、积压物资：在一个自然年内单品物资销存率＜1即视为该物资形成积压;</p>
            <p> 在K值＜1的范围内，根据积压分为一般积压、严重积压两类或多类。（各业务单位根据自己的业务特性自行分类）</p>
            <p>4、<img src={jiyalv} alt="" style={{ height: '50px'}}/></p>
            <p> 汽车行业积压率的标准K值为3%，＞3%即为不合格，＜3%为合格。（各业务单位根据自己的当前状况自行确定K值要求）</p>
            <p>5、<img src={chayilv} alt="" style={{ height: '50px'}}/></p>
            <p> 差异率的行业标准K值为3‰。（各业务单位根据自己的当前状况自行确定K值要求）</p>
            <p>6、<img src={nianzhoulv} alt="" style={{ height: '50px'}}/></p>
            <p> 周转率的行业标准K值为7.5，＞7.5为合格，＜7.5为不合格。 （各业务单位根据自己的当前状况自行确定K值要求）</p>
        </div>
        <br></br>
        <h3>八、 关于目标的定义</h3>
        <div style={{textIndent: '2em'}}>
            <p><strong
                style={{textIndent: '2em'}}>当下目标：</strong>我们每天要做到的事情。
            </p>
            <p><strong
                style={{textIndent: '2em'}}>短期目标：</strong>1年
            </p>
            <p><strong
                style={{textIndent: '2em'}}>中期目标：</strong>3—5年
            </p>
            <p><strong
                style={{textIndent: '2em'}}>长期目标：</strong>5—10年
            </p>
            <p><strong
                style={{textIndent: '2em'}}>愿景：</strong>一生追求的目标，是方向，是牵引我们向前的动力。
            </p>
        </div>
        <br></br>
        <h3>九、 营销收入和营销收益的区分</h3>
        <div style={{textIndent: '2em'}}>
            <p><strong
                style={{textIndent: '2em'}}>营销收入：</strong>主要是以货币为单位来计算的，直接明了。
            </p>
            <p><strong
                style={{textIndent: '2em'}}>营销收益：</strong>类似于边际贡献，主要由四部分组成。
            </p>
            <p><strong style={{textIndent: '2em'}}></strong>1.利润，也就是赚了多少钱
            </p>
            <p><strong style={{textIndent: '2em'}}></strong>2.企业品牌价值的提升，也就是社会影响力的提升
            </p>
            <p><strong
                style={{textIndent: '2em'}}> </strong> A
                上游资源、前端厂家的认可度</p>
            <p><strong
                style={{textIndent: '2em'}}> </strong> B
                下游资源、终端客户或用户的认可度</p>
            <p><strong style={{textIndent: '2em'}}></strong>3.团队竞争力
            </p>
            <p><strong style={{textIndent: '2em'}}></strong>4.经验教训（和学费是等价的）
            </p>
            <p><strong
                style={{textIndent: '2em'}}> </strong> A 失败的教训
            </p>
            <p><strong style={{textIndent: '2em'}}> </strong>B
                成功的经验</p>
        </div>
        <h3>十、 赚钱与值钱的区分</h3>
        <div style={{textIndent: '2em'}}>
            <p>1、赚钱是当下的，值钱是长期的，赚钱不一定值钱，值钱一定能赚钱。</p>
            <p>2、我们要让自己变得更值钱，而不是只顾眼下赚钱。</p>
            <p>3、值钱的前提是，要有自己的核心竞争力，要有自己的品牌。 </p>
        </div>
        <br></br>
        <h3>十一、 收入构成名词定义</h3>
        <div style={{textIndent: '2em'}}>
            <p><strong
                style={{textIndent: '2em'}}>1、职级工资：</strong>等同于基本工资，主要与岗位职责对应，做了分内的事得到该收入。
            </p>
            <p><strong
                style={{textIndent: '2em'}}>2、固定积分收入：</strong>员工固有的技能或潜能转换成价值，用积分的形式给予认可，积分最终会转换成价格，目的是让员工挖掘潜能达成目标，只有正激励。
            </p>
            <p><strong
                style={{textIndent: '2em'}}>3、动态积分收入：</strong>用积分的形式让管理变得更奖罚分明，更人性化，同时更激励员工去干更多的事情，拿到更多的收入，有正激励也有负激励。
            </p>
            <p><strong
                style={{textIndent: '2em'}}>4、突出贡献补贴：</strong>对优秀人才的引进给予的特殊奖金，是个案，不代表大多数。
            </p>
            <p><strong
                style={{textIndent: '2em'}}>5、年终奖金：</strong>根据员工一年的表现以及企业一年的收益，由企业负责人决定发放，不代表人人都有。
            </p>
            <p><strong
                style={{textIndent: '2em'}}>6、业绩提成：</strong>分为三种，销量提成、利润提成、工作量提成。主要是针对市场人员，按销售物品的金额或按比例或数量提成，以双方约定的协议为主。
            </p>
            <p><strong
                style={{textIndent: '2em'}}>7、创业空间：</strong>指2-4人组成一个独立核算小单元，接受公司的管理，按公司的制定标准开展工作，收入多少完全取决于创业空间的利润多少，原则上大多数利润都由创业空间的“微老板”所分配，公司只收取少部分平台费，创业空间的第一负责人称队长，创业空间的每一个人都称为“微老板”，目的是鼓励每一位员工都能自己创业，都能成为老板。创业空间也会吸纳社会资源共同加入公司平台。
            </p>
            <p><strong
                style={{textIndent: '2em'}}>8、承包收益：</strong>主要针对基层管理人员以上，可以是营销机构也可以是支持机构的负责人，针对某一领域作业内容或某一个项目确定一个量化的考核标准，用此标准来对应承包人的收入，以协议为准，可以是1个人也可以是几个人。
            </p>
            <p><strong
                style={{textIndent: '2em'}}>9、合伙人分红：</strong>针对某一个子公司或某一个独立核算单位，集团公司有投资，个人也有投资，按约定的比例分红。
            </p>
            <p><strong
                style={{textIndent: '2em'}}>10、年薪：</strong>针对高级管理人员或职业经理人或高端人才，明确其岗位职责，在岗位职责完成的
                情况下确定一个全年的总收入即为年薪，年薪可以按批次发放也可以一次性发放。</p>
            <p><strong
                style={{textIndent: '2em'}}>11、实股：</strong>用现金或等价实物投入到法人企业中，在章程中有列名，盈利与亏损均承担对应的权利和义务，是长期的。
            </p>
            <p><strong
                style={{textIndent: '2em'}}>12、干股：</strong>不投现金或有价实物，以技术或其它特殊贡献为资本，不在章程中体现，当事人与企业负责人私下约定，盈利分红，亏损无责，是短期的。
            </p>
            <p><strong
                style={{textIndent: '2em'}}>13、期权：</strong>是企业对当事人的一种承诺，往往用期票或协议的形式体现，与入资时间和兑现时间相关，随着公司所有者权益的增长而按比例增长，可先行约定保本条款，上市大赚，不上市小赚。
            </p>
        </div>
        <br></br>
    </div>
    <h2 name="0-0-5" className="point" id="point11">六、 工作法</h2>
    <div>
        <h3>一、 目标第一</h3>
        <div>
            <img src={mubiao1} alt="" style={{
                width: '600px',
                display: 'block',
                margin: '0 auto'
            }}/>
            <br/><br/>
        </div>
        <h3>二、 两个方向</h3>
        <div>
            <img src={fangxiang2} alt="" style={{
                width: '600px',
                display: 'block',
                margin: '0 auto'
            }}/>
            <br/><br/>
        </div>
        <h3>三、 三个焦点</h3>
        <div>
            <img src={jiaodian3} alt="" style={{
                width: '600px',
                display: 'block',
                margin: '0 auto'
            }}/>
            <br/><br/>
        </div>
        <h3>四、 四个步骤</h3>
        <div>
            <img src={buzhou4} alt="" style={{
                width: '600px',
                display: 'block',
                margin: '0 auto'
            }}/>
            <br/><br/>
        </div>
        <h3>五、 五个原则--5W原则</h3>
        <div>
            <img src={smart5} alt="" style={{
                width: '600px',
                display: 'block',
                margin: '0 auto'
            }}/>
            <br/><br/>
        </div>
        <h3>六、 六大能力</h3>
        <div>
            <img src={nengli6} alt="" style={{
                width: '600px',
                display: 'block',
                margin: '0 auto'
            }}/>
            <br/><br/>
        </div>
        <h3>七、 七个定律</h3>
        <div>
            <img src={dinglv7} alt="" style={{
                width: '600px',
                display: 'block',
                margin: '0 auto'
            }}/>
            <br/><br/>
        </div>
        <h3>八、 八大执行力秘诀</h3>
        <div>
            <img src={mijue8} alt="" style={{
                width: '600px',
                display: 'block',
                margin: '0 auto'
            }}/>
            <br/><br/>
        </div>
        <h3>九、 九点领导力</h3>
        <div>
            <img src={lingdaoli9} alt="" style={{
                width: '600px',
                display: 'block',
                margin: '0 auto'
            }}/>
            <br/><br/>
        </div>
    </div>
    <br/>
    <br/>
    <br/>
    {/*第一章end*/}

</div>;

export default Section1;